import { ContainerSelected } from "components/Environment/shared/BuildTypes";
import { DrawerClose } from "components/Graphs/Drawer";
import React, { useMemo, useState } from "react";
import BaseContainerSelector from "../ContainerSelector/BaseContainerSelector";

interface DrawerContainerSelectorProps {
  selectedContainer: ContainerSelected;
  setSelectedContainer: (container: ContainerSelected) => void;
  pythonVersion: string;
  setPythonVersion: (pythonVersion: string) => void;
  cudaVersion: string;
  setCudaVersion: (cudaVersion: string) => void;
  closeDrawer: () => void;
  lifecycleScriptTab: "upload" | "paste";
  setLifecycleScriptTab: (tab: "upload" | "paste") => void;
  lifecycleScriptFile: File | null;
  setLifecycleScriptFile: (file: File | null) => void;
}

const DrawerContainerSelector: React.FC<DrawerContainerSelectorProps> = ({
  selectedContainer,
  setSelectedContainer,
  pythonVersion,
  setPythonVersion,
  cudaVersion,
  setCudaVersion,
  closeDrawer,
  lifecycleScriptTab,
  setLifecycleScriptTab,
  lifecycleScriptFile,
  setLifecycleScriptFile,
}) => {
  const [localSelectedContainer, setLocalSelectedContainer] =
    useState<ContainerSelected>(selectedContainer);
  const [localPythonVersion, setLocalPythonVersion] =
    useState<string>(pythonVersion);
  const [localCudaVersion, setLocalCudaVersion] = useState<string>(cudaVersion);
  const [localLifecycleScriptTab, setLocalLifecycleScriptTab] = useState<
    "upload" | "paste"
  >(lifecycleScriptTab);
  const [localLifecycleScriptFile, setLocalLifecycleScriptFile] =
    useState<File | null>(lifecycleScriptFile);

  const handleApply = () => {
    setSelectedContainer(localSelectedContainer);
    if (localSelectedContainer.verbBuild?.containerUrl === "Default") {
      setCudaVersion(localCudaVersion);
      setPythonVersion(localPythonVersion);
    }
    if (localSelectedContainer.vmBuild) {
      // Save local lifecycle script UI states to parent
      setLifecycleScriptTab(localLifecycleScriptTab);
      setLifecycleScriptFile(localLifecycleScriptFile);
    }
    closeDrawer();
  };

  return (
    <div>
      <BaseContainerSelector
        selectedContainer={localSelectedContainer}
        onContainerChange={setLocalSelectedContainer}
        pythonVersion={localPythonVersion}
        onPythonVersionChange={setLocalPythonVersion}
        cudaVersion={localCudaVersion}
        onCudaVersionChange={setLocalCudaVersion}
        lifecycleScriptTab={localLifecycleScriptTab}
        onLifecycleScriptTabChange={setLocalLifecycleScriptTab}
        lifecycleScriptFile={localLifecycleScriptFile}
        onLifecycleScriptFileChange={setLocalLifecycleScriptFile}
        showApplyButton={true}
        onApply={handleApply}
        applyButtonText="Apply"
        showCustomContainer={true}
      />
    </div>
  );
};

export default DrawerContainerSelector;
